module.exports = __webpack_public_path__ + "static/home-banner1-min-6667856f6e6b61cf1f504f48e6df48d4.png";